// test1406
(1406 && 0);
